import { useContext, memo } from "react";
import ReactPlayer from "react-player";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// assets
import updateIcon from "bodycodi/cmap/app/img/update-white.png";
import deleteIcon from "bodycodi/cmap/app/img/delete-white.png";

// types
import { RenderVideoLinksProps } from "./types";

const RenderVideoLinks = ({
  videoLinks,
  setVideoLinks,
  setLinkToEdit,
  setOpenAddLink,
}: RenderVideoLinksProps) => {
  const { dispatch } = useContext(DispatchContext);

  const handleUpdate = (e: any, link: string) => {
    e.stopPropagation();
    setLinkToEdit(link);
    setTimeout(() => {
      setOpenAddLink(true);
    }, 100);
  };

  const handleDelete = (e: any, index: number) => {
    e.stopPropagation();
    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: "D",
        redYn: true,
        header: "컨텐츠 삭제",
        body: "해당 컨텐츠를 \n삭제하시겠습니까?",
        cancelAlert: () => {},
        closeAlert: () => {
          const list = videoLinks.filter((d: any, i: number) => {
            return index !== i;
          });
          setVideoLinks([...list]);
        },
      },
    });
  };

  return (
    <>
      {videoLinks?.map((item: any, index: number) => {
        return (
          <div className="file-handler player" key={index}>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url={item.link}
              playing={false}
              controls={false}
            />
            <div className="btn-wrap">
              {!item.link.includes("vimeo") && (
                <>
                  <div className="btn1" onClick={(e) => handleUpdate(e, item.link)}>
                    <img src={updateIcon} />
                  </div>
                  <hr />
                </>
              )}
              <div className="btn1" onClick={(e) => handleDelete(e, index)}>
                <img src={deleteIcon} />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default memo(RenderVideoLinks);
